// extracted by mini-css-extract-plugin
export default {"panel":"Panel_panel__4RHjo","restrictedWidth":"Panel_restrictedWidth__20uyE"};